import { includes } from 'lodash'
import { API_BASE_URL } from 'common/misc/constants'
import headers from './headers'

const options = (
    method,
    url,
    data,
    source = '',
    fileType = '',
    extraParams
) => {
    let options = {
        headers: headers(source, fileType, data),
        method,
        url: `${
            includes(['upload', 'external'], source)
                ? url
                : `${API_BASE_URL}/${url}`
        }`,
        data,
    }
    if (extraParams) options = { ...options, ...extraParams }
    if (includes(source, ['external'])) {
        delete options.headers
        delete options.data
    }

    return options
}

export default options
